import {request} from "../request/request";

const invitation = {
  getMy: (params) => request.read('/invitation/my', params, true),
  postPrepare: (data) => request.create('/invitation/prepare', data, true),
  putViewed: (invitationId) => request.update(`/invitation/${invitationId}/viewed`, null, true),
};

export {invitation};